import React from 'react'
import TypographyUI from '@material-ui/core/Typography';

function Typography(props) {
    return (
        <TypographyUI {...props} />
    )
}


export default (Typography);